<template>
	<div class="aboutus">
		<div class="bannerimgbox"><img :src="banner.image" @click="bannerTo(banner.url)"></div>
		<div class="content">
			<el-tabs v-model="pageName" @tab-click="handleClick" >
			    <el-tab-pane label="公司介绍" name="industribute"  >
					<div class="instrut"></div>
					<div v-html="comIntro.content">

					</div>
					<!--<div class="instrut" >-->
						<!--<div class="inline halfw instp">-->
							<!--<p class="ppadding"> 始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不</p>-->
							<!--<p> 始始发货时间发货是否会始发货时间发货始发货时间发货是否会始发货时间发货始发货时间发货是否会始发货时间发货发货时间发货是否会始发货时间发货是否会发货时间发货是否会始发货时间发货是否会发货时间发货是否会始发货时间发货是否会第三方的很费时间的封建时代不符合发生的回复公司电始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不话发生纠纷和第三方告诉警方核实是否是辐射防护好的发</p>-->
						<!--</div>-->
						<!--<div class="inline halfw">-->
							<!--<img src="../assets/images/instru.png" />-->
						<!--</div>-->
					<!--</div>-->
					<!--<div class="textl instb">-->
						<!--<p class="ppadding"> 封建会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不</p>-->
						<!--<p class="pt">聚宝源置业</p>-->
						<!--<p class="ppadding"> 始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不</p>-->
						<!--<p class="pt">聚宝源建工</p>-->
						<!--<p class="ppadding"> 始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不</p>-->
						<!--<p class="pt">聚宝源商管</p>-->
						<!--<p class="ppadding"> 始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不</p>-->
						<!--<p class="ppadding"> 始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不始发货时间发货是否会第三方的很费时间的封建时代不</p>-->
					<!--</div>-->
				</el-tab-pane>
			    <el-tab-pane label="品牌故事" name="story">
            <div class="imgttsto">

            </div>
                    <div v-html="brandHist.content">

                    </div>
<!-- 			    <el-tab-pane label="品牌故事" name="story">-->

					<div class="timebox" v-if="brandHist.time_story">
						 <el-timeline>
						    <el-timeline-item :timestamp="item.year" placement="top" v-for="item in brandHist.time_story">
						      <div>
						        <p class="storyPP" v-for="contentItem in item.content">{{contentItem}}</p>
						      </div>
						    </el-timeline-item>
							<!--<el-timeline-item timestamp="1999" placement="top">-->
							  <!--<div>-->
							    <!--<p class="storyPP">舒服很多粉红色规范时间和反对发射点受到核辐射的是否记得发积分环节都是和第三方是股市大幅v第三个</p>-->
								<!--<p class="storyPP">王小虎 提交于 2018/4/12 20:46</p>-->
							  <!--</div>-->
							<!--</el-timeline-item>-->
							<!--<el-timeline-item timestamp="1999" placement="top">-->
							  <!--<div>-->
							    <!--<p class="storyPP">王小虎 提交于 2018/4/12 20:46</p>-->
								<!--<p class="storyPP">王小虎 提交于 2018/4/12 20:46</p>-->
							  <!--</div>-->
							<!--</el-timeline-item>-->
						</el-timeline>
					</div>
				</el-tab-pane>
			    <el-tab-pane label="新闻动态" name="news">
					<div class="newsbox" v-if="!showNewsDetail">
						<div class="inline newsl">
							<img :src="newsBanner.image" />
						</div>
						<div class="inline newsr">
							<div class="listitem" v-for="(item,index) in newsList" @click="showNewDetail(index)">
								<div class="newlistTitle">{{item.title}}</div>
								<div class="newlistcontent">{{item.brief}}</div>
								<div class="newlisttime">{{item.create_time}}</div>
							</div>
							<!--<div class="listitem" @click="showNewDetail('item')">
								<!--<div class="newlistTitle" >聚宝源及时发货时间发及时发货</div>-->
								<!--<div class="newlistcontent">聚宝源及时聚宝源及时发货聚宝源及聚宝源及时发货聚宝源及时发货聚宝源及时发货时发货聚宝源及时发货聚宝源及时发货聚宝源及时发货聚宝源及时发货发货时间发及时发货</div>-->
								<!--<div class="newlisttime">2020.1.2</div>-->
							<!--</div>-->
							<!--<div class="listitem" @click="showNewDetail('item')">-->
								<!--<div class="newlistTitle">聚宝源及时发货时间发及时发货</div>-->
								<!--<div class="newlistcontent">聚宝源聚宝源及时发货聚宝源及时发货聚宝源及时发货及时发货时间发及时发货</div>-->
								<!--<div class="newlisttime">2020.1.2</div>-->
							<!--</div>-->
							<!--<div class="listitem" @click="showNewDetail('item')">-->
								<!--<div class="newlistTitle">聚宝源及时发货时间发及时发货</div>-->
								<!--<div class="newlistcontent">聚宝源及时聚宝源及时发货聚宝源及时发货聚宝源及时发货聚宝源及时发货发货时间发及时发货</div>-->
								<!--<div class="newlisttime">2020.1.2</div>-->
							<!--</div>-->
							<div class="pagebox">
								 <el-pagination
								  :total="count"
								  prev-text='上一页'
								  next-text='下一页'
								  background
                                  :page-size="pageSize"
								  :current-page.sync="currentPage"
								   @current-change="handleCurrentChange"
								  layout="prev, pager, next">
								</el-pagination>
							</div>
						</div>
					</div>
					<div class="newsboxdetail" v-if="showNewsDetail">
						<div class="newdetailTit" v-html="newsDetail.title"></div>
						<div class="newsdetailTime"><span class="icontr"></span>{{newsDetail.create_time}}</div>
						<div class="newdetailContent" v-html="newsDetail.content">
							<!--<div class="inline detaillcon">-->
								<!--<img src="../assets/images/news1.png" />-->
							<!--</div>-->
							<!--<div class="inline detailrcon">-->
								<!--<p class="detailb">数据格式的回复uu飒飒官方答复是广东省风格和施工方付啊水水梵蒂据格式的回复uu飒飒官方答复是广东省风格和施工方付啊水水梵蒂据格式的回复uu飒飒官方答复是广东省风格和施工方付啊水水梵蒂据格式的回复uu飒飒官方答复是广东省风格和施工方付啊水水梵蒂冈三十公分的是否该事故发生的回复</p>-->
								<!--<p class="detailb">数据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省飒官方答复是广东省据格式的回复uu飒飒官方答复是广东省风格和施工方付啊水水梵蒂据格式的回复uu飒飒官方答复是广东省风格和施工方付啊水水梵蒂据格式的回复uu飒飒官方答复是广东省风格和施工方付啊水水梵蒂据格式的回复uu飒飒官方答复是广东省风格和施工方付啊水水梵蒂冈三十公分的是否该事故发生的回复</p>-->
							<!--</div>-->
						</div>
						<div class="clear pagett">
							<div class="inline" @click="newsToPrev">< 上一篇：{{newsPrev.title}}</div>
							<div class="flr inline" @click="newsToNext">下一篇：{{newsNext.title}} ></div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
  name: 'aboutUs',
  data () {
    return {
      pageName:'industribute',
      banner:[],
      newsBanner:[],
	  showNewsDetail:false,
      pageSize:4,
	  currentPage:1,
      count:0,
      comIntro:[],
      brandHist:[],
      newsList:[],
      prevPageNews:[],
      nextPageNews:[],
      newsDetail:[],
      newsPrev:[],
      newsNext:[],
      currentIndex:0,
    }
  },
  watch:{
      $route(val){
		  this.pageName = val.params.id
	  }
    },
  mounted() {
  	this.$nextTick(()=>{
  		this.pageName = this.$route.params.id
  	});
  	this.getBanner();
  	this.getNewsBanner();
  	this.getComIntro();
  	this.getBrandHist();
  	this.getNewsList(false);
  },
  methods:{
	handleClick(){
		this.showNewsDetail = false;
	},
	handleCurrentChange(val){
		this.currentPage = val
        this.getNewsList(false);

	},
	showNewDetail(index){
        this.currentIndex = index;
		this.showNewsDetail = true;
		this.newsDetail = this.newsList[index];
		this.getPrevNextNews(index);
	},
    getBanner: async function () {
        const res = await this.$getJSON('/index/banner',{cat_id:6});
        this.banner = res.data.detail;
    },
    getNewsBanner: async function () {
	    const res = await this.$getJSON('/index/banner',{cat_id:10});
        this.newsBanner = res.data.detail;
    },
    getPrevNextNews(index){
        if(index == 0){
            this.newsPrev = this.prevPageNews != null?this.prevPageNews:{id:0,title:'无'};
        } else {
            this.newsPrev = this.newsList[index - 1];
        }
        if(index == this.newsList.length - 1) {
            this.newsNext = this.nextPageNews != null?this.nextPageNews:{title:'无'};
        } else {
            this.newsNext = this.newsList[index + 1];
        }
    },
    newsToPrev() {
        if(this.currentIndex == 0 && this.currentPage > 1) {
            this.currentPage --;
            this.currentIndex = this.pageSize - 1;
            this.getNewsList(true);
        } else {

            this.currentIndex --;
            this.newsDetail = this.newsList[this.currentIndex];
            this.getPrevNextNews(this.currentIndex);
        }
    },
    newsToNext: async function() {
        if(this.currentIndex == this.newsList.length - 1 && this.nextPageNews != null) {
            this.currentPage ++;
            this.currentIndex = 0;
            this.getNewsList(true);
        } else {
            this.currentIndex ++;
            this.newsDetail = this.newsList[this.currentIndex];
            this.getPrevNextNews(this.currentIndex);
        }

    },
    // 加载公司简介
    getComIntro: async function () {
        const res = await this.$getJSON('/index/about');
        this.comIntro = res.data.detail;
    },
    getBrandHist: async function() {
        const res = await this.$getJSON('/index/brandHist');
        this.brandHist = res.data.detail;
    },
    getNewsList: async function(isChange) {
        const res = await this.$getJSON('/index/newsList',{page:this.currentPage});
        this.newsList = res.data.list;
        this.prevPageNews = res.data.prevPageNews;
        this.nextPageNews = res.data.nextPageNews;
        this.count = res.data.count;

        if(isChange){
            this.newsDetail = this.newsList[this.currentIndex];
            this.getPrevNextNews(this.currentIndex);
        }
    },
    bannerTo: function (url) {
        if(url === ""){
            return;
        } else if(url.substring(0, 1) == "/") {
            this.$router.push({path: url})
        } else {
            window.location.href = url;
        }
    }

  }
}
</script>

<style scoped>
	.pagett .flr{
		text-align: right;
	}
	.el-tab-pane{
		padding: 0px 10px;
		box-sizing: border-box;
	}
	.bannerimgbox img{
		width: 100%;
		display: block;
	}
	.aboutus{
		padding-top: 20px;
	}
	.imgttsto{
		padding-top: 94px;
	}
	.pagett .inline{
		/* width: fit-content; */
		margin-bottom: 100px;
		}
		.pagett>div{
			width: 48%!important;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	.newdetailContent{
		margin-top: 40px;
		margin-bottom: 80px;
	}
	.detaillcon{
		vertical-align: top!important;
	}
	.detaillcon img{
		width: 522px;
		height: 342px;
		overflow: hidden;
	}
	.detailrcon{
		vertical-align: top!important;
		width: 50%;
		padding-left: 6%;
		line-height: 27px;
		height: 342px;
		overflow: hidden;
	}
	.detailb{
		padding-bottom: 20px;
	}
	.newsdetailTime{
		color: #9a9a9a;
		line-height: 50px;
	}
	.newsdetailTime .icontr{
		width: 0px;
		height: 0px;
		display: inline-block;
		margin-bottom: 2px;
		margin-right: 10px;
		border: 4px solid #9a9a9a;
		border-right-color: transparent;
		border-top-color: transparent;
		border-bottom-color: transparent;
	}
	.newsboxdetail{
		margin-top: 40px;
		text-align: left;
	}
	.newdetailTit{
		font-size: 40px;
		width: 800px;
		display: -webkit-box;
		margin-bottom: 10px;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}
	/deep/.el-pagination button, .el-pagination span:not([class*=suffix]) {
	    height: 28px;
	    padding: 5px 10px;
	    line-height: 20px;
	}
	.pagebox{
		padding-top: 40px;
	}
	.newsr{
		width: 54%;
		vertical-align: top!important;
		padding-left: 80px;
		box-sizing: border-box;

	}
	.newlistTitle{
		font-size: 20px;
		width: 100%;
		overflow: hidden;
		line-height: 30px;
		text-overflow: ellipsis;
		white-space: normal;
		padding-bottom: 10px;
		color: #9E856F;
		text-align: left;
	}
	.listitem{
		cursor: pointer;
		padding-bottom: 2px;
		margin-bottom: 14px;
		border-bottom: 1px solid #f3f3f3;
	}
	.listitem:last-child{
		border-bottom: 0px!important!important;
	}
	.newlistcontent{
		display: -webkit-box;
		line-height: 26px;
		margin-bottom: 10px;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		font-size: 16px;
		text-align: left;
	}
	.newlisttime{
		font-size: 16px;
		text-align: left;
		padding-bottom: 10px;
	}
	.newsl{
		vertical-align: top!important;
		padding-bottom: 60px;

	}
	.newsbox{
		padding: 100px 0px;
		text-align: left;
	}
	.timebox{
		margin: 190px 0px 100px 0px
	}

	.instrut{
		padding: 10px;
		box-sizing: border-box;
		/* border-bottom: 2px solid #f3f3f3; */
	}
	.halfw{
		width: 49%;
		padding: 0px 30px;
		margin:20px 0px;
		box-sizing: border-box;
	}
	.instp{
		line-height: 26px;
		text-align: left;
		height: 216px;
		overflow: hidden;
	}

	.ppadding{
		padding-bottom: 10px;
	}

	/deep/.el-timeline .el-timeline-item:last-child .el-timeline-item__tail {
	    display: block;
	}
	.pt{
		padding-top: 20px;
		font-weight: bolder;
		padding-bottom: 6px;
	}
	.instb{
		line-height: 24px;
		padding: 40px 46px 120px 48px;
		font-size: 16px;
		box-sizing: border-box;
	}
	/deep/.el-timeline-item .el-timeline-item__timestamp {
	    color: #9e856f;
	    line-height: 2rem;
	    font-size: 20px;

	}
	/deep/.el-timeline-item{
		margin-top: -70px;
	}
	/deep/.el-timeline-item:nth-child(2n+1) .el-timeline-item__timestamp{
		padding-left: 40px;
		box-sizing: border-box;
		text-align: left;
	}
	/deep/.el-timeline-item:nth-child(2n) .el-timeline-item__timestamp{
		padding-right: 60px;
		box-sizing: border-box;
		text-align: right;
	}
	/deep/.el-timeline-item .el-timeline-item__content {
	    padding: 0px 0px 0px 45px;
	    color: #303133;
	    /*width: 68%;*/
	    box-sizing: border-box;
	    text-align: left;
	}
	/deep/.el-timeline-item:nth-child(2n) .el-timeline-item__content{
        /*padding: 1px 0px 0px 224px;*/
	    color: #303133;
	    width: 89%;
		box-sizing: border-box;
		text-align: right;
	}
/* 	.el-timeline-item{
		width: 100%;
	} */
	.storyPP{
		font-size: 14px;
		line-height: 20px;
		padding-bottom: 20px;
	}
	/deep/.el-timeline-item:nth-child(2n){
		width: 50%;
	}
	/deep/.el-timeline-item:nth-child(2n) .el-timeline-item__tail{
		right: -6px;
		left: unset;
	}
  @media screen and ( min-width: 751px ){
    /deep/.el-timeline-item:nth-child(2n)  .el-timeline-item__node--normal {
      right: -13px;
      left: unset;
      width: 6px;
      height: 6px;
    }
    /deep/.el-timeline-item__node{
      /* position: relative; */
      z-index: 2;
    }
  }
	/deep/.el-timeline-item:nth-child(2n+1){
		margin-left: 50%;
	}

	/deep/.el-timeline-item__node:before{
		position: absolute;
		content: '';
		width: 10px;
		height: 10px;
		border-radius: 50%;
		border: 1px solid #afafaf;
		background-color: transparent;
		z-index: -1;
	}
</style>



// WEBPACK FOOTER //
// src/vew/aboutUs.vue